/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const lastActivityFilterSchema = z.enum(['anytime', 'last_24h', 'last_7d', 'last_30d'])

export type LastActivityFilterSchema = z.infer<typeof lastActivityFilterSchema>
